import React from 'react'
import NumberFormat from 'react-number-format'
import { Col, Input, InputGroup, Row } from 'rsuite'
import { isValidators } from '../../../utils/ValidatorUtils'
import InputNumberForm from '../input/InputNumberForm'

export default function CheckboxRowHaveSubView(props) {
  const {
    schema,
    register,
    errors,
    Controller,
    control,
    setValue,
    clearErrors,
    isInput,
    inputKey,
  } = props

  const validateSelect = (data) => {
    // let result = false
    if (data.isItem) {
      return schema.optionSelected?.includes(data.value)
    } else {
      let arrayList = data?.childs || []
      for (let i = 0; i < arrayList.length; i++) {
        let result = validateSelect(arrayList[i])
        if (result) {
          return result
        }
      }
    }
  }

  const renderView = (data, keyStr) => {
    if (data?.isTitle) {
      let result = validateSelect(data)
      if (result) {
        return (
          <div key={`div_title_${keyStr}`}>
            <p>
              <b>{data.label}</b>
            </p>
            {data?.childs?.map((item, index) => {
              return renderView(item, `title_${keyStr}_${index}`)
            })}
          </div>
        )
      }
    } else if (data?.isSubTitle) {
      let result = validateSelect(data)
      if (result) {
        return (
          <div key={`div_subtitle_${keyStr}`} style={{ marginLeft: 20 }}>
            <p>
              <b>{data.label}</b>
            </p>
            {data?.childs?.map((item, index) => {
              return renderView(item, `subTitle_${keyStr}_${index}`)
            })}
          </div>
        )
      }
    } else if (data?.isItem) {
      if (data?.isGroupTitle && data?.isGroupSelected) {
        return <div style={{ marginLeft: 10, marginTop: 10, fontWeight: 550 }}> {data.label}</div>
      }

      return (
        <ul key={`data_${keyStr}`}>
          {schema.optionSelected?.includes(data.value) && (
            <>
              {isInput ? (
                <Row>
                  <Col xs={3} sm={3} md={3} lg={3} style={{ width: 80 }}>
                    <InputNumberForm
                      schema={{
                        value: data.percentage || 0.0,
                        hint: 'ระบุสัดส่วน',
                        name: `${inputKey}${data.value}`,
                        validators: [],
                      }}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      decimalScale={2}
                      //inputWidth={70}
                    />
                  </Col>
                  <Col xs={21} sm={21} md={21} lg={21}>
                    <p style={{ paddingTop: 5 }}>{data.label}</p>
                  </Col>
                </Row>
              ) : (
                <li key={data.value} style={{ marginBottom: 8 }}>
                  {data.label}
                </li>
              )}
            </>
          )}
        </ul>
      )
    }
  }

  return (
    <div>
      {schema.optionSelected.length === 0 ? (
        <span>- ไม่ได้ระบุ -</span>
      ) : (
        <>
          {schema.options.map((item, index) => {
            return <div key={index}>{renderView(item, index)}</div>
          })}
        </>
      )}

      {/* {schema.optionSelected.length === 0 && !schema.inputOther?.isSelected ? (
              <span>- ไม่ได้ระบุ -</span>
            ) : (
              <ul>
                {schema.optionSelected.map((item) => {
                  const _selected = schema.options.filter((i) => i.value === item)
                  const _label = _selected.length ? _selected[0].label : ''
                  return (
                    <li key={item} style={{ marginBottom: 8 }}>
                      {_label}
                    </li>
                  )
                })}
              </ul>
            )}
            <ul>
              {schema.inputOther?.enable && schema.inputOther?.isSelected && (
                <li>{schema.inputOther.value}</li>
              )}
            </ul> */}
    </div>
  )
}
